import type { LabeledOption } from '@iheartjane/types';

import type { SortOptions } from '@jane/bloom/types/schemas/algolia/product';
import {
  CURRENT_PAGE_QUERY_KEY,
  SEARCH_TERM_QUERY_KEY,
} from '@jane/bloom/utils/queryParams/queryParams';

interface GetFiltersCountArgs {
  searchParams: URLSearchParams;
  sortOptions: LabeledOption<SortOptions>[];
}

export const getFiltersCount = ({
  searchParams,
  sortOptions,
}: GetFiltersCountArgs) => {
  const paramsCopy = new URLSearchParams(searchParams);
  paramsCopy.delete(CURRENT_PAGE_QUERY_KEY);
  paramsCopy.delete(SEARCH_TERM_QUERY_KEY);
  paramsCopy.delete('transactionId');
  const sortValue = paramsCopy.get('sort');

  const isDefault = sortValue === sortOptions[0].value;

  // We don't want to include the default sort into the filters count
  if (isDefault) {
    paramsCopy.delete('sort');
  }

  const remainingKeys = Array.from(paramsCopy.keys());
  return remainingKeys.length;
};
